/* Image slider inside product cards. Uses native scroll-snap; this only wires up arrows, dots and swatch resets. */
(() => {
  if (window.customElements.get('product-card-slider')) return;

  class ProductCardSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');
      this.dots = Array.from(this.querySelectorAll('.product-card__slider-dot'));
      if (!this.track) return;

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prev?.addEventListener('click', (e) => this.step(e, -1));
      this.next?.addEventListener('click', (e) => this.step(e, 1));

      // When a color swatch changes the main image, jump back to the first slide.
      this.closest('product-card')?.addEventListener('change', (e) => {
        if (e.target.matches('.product-card__info [type="radio"]')) this.goTo(0, 'auto');
      });

      this.update();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
    }

    get count() {
      return this.track.children.length;
    }

    get index() {
      const width = this.track.clientWidth || 1;
      return Math.round(Math.abs(this.track.scrollLeft) / width);
    }

    step(event, dir) {
      event.preventDefault();
      event.stopPropagation();
      this.goTo(this.index + dir);
    }

    goTo(i, behavior = 'smooth') {
      const index = Math.max(0, Math.min(this.count - 1, i));
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollTo({ left: (rtl ? -1 : 1) * index * this.track.clientWidth, behavior });
    }

    onScroll() {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => this.update());
    }

    update() {
      const i = this.index;
      this.dots.forEach((dot, n) => dot.classList.toggle('is-active', n === i));
      if (this.prev) this.prev.disabled = i <= 0;
      if (this.next) this.next.disabled = i >= this.count - 1;
    }
  }

  window.customElements.define('product-card-slider', ProductCardSlider);
})();
